import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const listTwoColInit = () => {
    const modules = document.querySelectorAll('.gg-list-two-col');
    modules.forEach((module) => {
        const groupListItem = module.querySelector('.gg-list-two-col__group-list-item');
        
        if (groupListItem) {
            const listItems = groupListItem.querySelectorAll('li');
            if(listItems.length > 0) {
                listItems.forEach((listItem, index) => {
                    listItem.classList.add('fade-in-up', `delay-${index + 2}`);
                });
            }
        }
    });
};

Gravity.ready(listTwoColInit);
